"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const clock_1 = require("./clock");
class Timer {
    constructor() {
        this.start();
    }
    start() {
        this._start = clock_1.Clock.Now();
    }
    stop() {
        const dur = clock_1.Clock.Now() - this._start;
        this._start = null;
        return dur;
    }
    lap() {
        const dur = clock_1.Clock.Now() - this._start;
        return dur;
    }
}
exports.Timer = Timer;
